<template lang="pug">
	.editor-control-range(:class="{'change-process': changedValue !== null, [theme]: true}")
		.input-title(v-if="title") {{title}}
		.number-input(v-if="!noInput")
			label(v-on:wheel="processChangeValueByMouseWheel($event)")
				input.form-control.form-control-sm(:value="getDisplayedValue()" v-on:keydown="startChangeValueByKeyPress($event)" v-on:keyup="changeValueByInput($event.target.value, $event, false)" v-on:change="changeValueByInput($event.target.value, $event)" v-on:focus="blockUpdate()" v-on:blur="unblockUpdate()")
		.range-input(v-on:wheel="processChangeValueByMouseWheel($event)")
			input.custom-range(type="range" :value="getValue()" :min="options.controlOptions.min" :max="options.controlOptions.max" :step="options.controlOptions.step" v-on:input="changeValueByInput($event.target.value)")
</template>

<script>

	import Screen 							from './../../../mixins/screen'

	export default {
		name: 'InputRange',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {}
		},
		components: {},
		props: {
			'title': String,
			'default': Number,
			'value': Number,
			'options': Object,
			'theme': String,
			'noInput': Boolean
		},
		data() {

			this.element = null;

			this.keyPressProcess = null;

			return {
				showed: true,
				changedValue: null
			};

		},
		mounted() {

			window.addEventListener("keydown", e => {

				if (this.keyPressProcess) {

					if (e.keyCode === 16) this.keyPressProcess.shiftKey = true;

				}

			});

			window.addEventListener("keyup", e => {

				if (this.keyPressProcess) {

					if (e.keyCode === 38 || e.keyCode === 40) this.stopChangeValueByKeyPress();
					if (e.keyCode === 16) this.keyPressProcess.shiftKey = false;

				}

			});

		},
		methods: {
			collectData() {

			},
			getValue() {

				let value = null;

				// console.log('getValue this.changedValue', this.changedValue, 'this.value', this.value, 'this.default', this.default);

				if (this.changedValue !== null && this.changedValue !== undefined) value = this.changedValue;
				else if (this.value !== null && this.value !== undefined) value = this.value;
				else value = this.default;

				value = this.restoreValueType(value);

				return value;

			},
			getDisplayedValue() {

				let value = this.getValue();

				if (this.options.controlOptions?.percents) value = `${parseInt(value * 100)}%`;
				else if (this.options.changes && "accuracy" in this.options.changes) value = parseInt(value * Math.pow(10, this.options.changes.accuracy)) / Math.pow(10, this.options.changes.accuracy);

				return value;

			},
			setValue(value) {

				this.changedValue = this.restoreValueType(value);

				this.$emit('input', this.changedValue);

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', this.changedValue);

					clearTimeout(this.sendTimeout); // используем именно this.sendTimeout чтобы этот второй таймаут остановился в случае новых изменений после отправки change события
					this.sendTimeout = setTimeout(() => {

						this.changedValue = null;
						this.update();

					}, 300); // Даём 300мс на сохранение данных на сервере

				}, 500);

			},
			processChangeValueByMouseWheel(e) {

				this.changeValue(Math.sign(e.wheelDelta), e.shiftKey);

			},
			changeValueByInput(value, e = null) {

				if (!e || (e.keyCode !== 38 && e.keyCode !== 40)) {

					// Если вводить значение "0.3" то при написании второго символа "0." код обновляет поле ввода назад на "0" и становится невозможно ввести "0.3" поэтому пропустим тут обновление при временно невалидных значениях
					if (parseFloat(value)+'' !== value) return;

					value = parseFloat(value);

					if (!_.isNaN(value)) this.setValue(value);

				}

			},
			startChangeValueByKeyPress(e) {

				if (e.keyCode === 38 || e.keyCode === 40) {

					if (!this.keyPressProcess) {

						this.keyPressProcess = {
							increaser: e.keyCode === 40 ? -1 : 1,
							shiftKey: e.shiftKey
						};

						this.keyPressProcess.timeout = setTimeout(() => {

							this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

							this.keyPressProcess.interval = setInterval(() => {

								this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

							}, 50);

						}, 200);

						this.changeValue(this.keyPressProcess.increaser, this.keyPressProcess.shiftKey);

					}

					e.preventDefault();

				}

			},
			stopChangeValueByKeyPress() {

				if (this.keyPressProcess) {

					clearTimeout(this.keyPressProcess.timeout);
					clearInterval(this.keyPressProcess.interval);

					this.keyPressProcess = null;

				}

			},
			changeValue(increaser, shiftKey) {

				console.log('changeValue', increaser, shiftKey);

				let newValue = this.getValue() + this.options.changes.step * increaser * (shiftKey ? 10 : 1);

				if (newValue < this.options.changes.min) newValue = this.options.changes.min;
				if (newValue > this.options.changes.max) newValue = this.options.changes.max;

				this.setValue(newValue);

			},
			restoreValueType(value) {

				return parseFloat(value);

			},
			blockUpdate() {

				// Запрещаем апдейт компонента пока фокус стоит в поле ввода информации
				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;

				// Пробуем через таймаут обновить компонент
				// Если updateBlocked к этому моменту всё ещё будет false то компонент обновится и отобразит новые клиентские данные
				// Это делается чтобы заблокировать обновление полей ввода пока пользователь не завершил их ввод
				// Без этого автообновления мешают печатать новые значения в полях типа coords
				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

			}
		}

	}
</script>

<style lang="sass">

	.editor-control-range.dark-mini
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		min-height: 31px
		align-items: center

		.input-title
			display: flex
			justify-content: right
			//width: 100px
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.number-input
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			border-radius: 0.1rem
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border: 1px solid rgba(255, 255, 255, 0.09)
			transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out
			overflow: hidden
			width: 60px
			height: 24px

			label
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin: 0
				padding: 0

			input
				margin: 0
				width: 58px
				height: 100%
				box-shadow: none
				outline: none !important
				border-radius: 0
				border: none
				background-color: transparent
				padding: 0 3px

		.range-input
			margin-left: 10px
			margin-top: 3px
			width: 78px
			cursor: pointer

			//.custom-range::-ms-track,
			.custom-range::-moz-range-track,
			.custom-range::-webkit-slider-runnable-track
				height: 3px
				background-color: rgba(255, 255, 255, 0.09)
				cursor: pointer

			//.custom-range::-ms-thumb,
			.custom-range::-moz-range-thumb,
			.custom-range::-webkit-slider-thumb
				width: 10px
				height: 10px
				background-color: #383d47
				border: 1px solid rgba(255, 255, 255, 0.09)
				cursor: pointer
				box-shadow: none

	.editor-control-range.dark-mini.change-process

		.title
			color: #20a8d8

		.range-input

			//.custom-range::-ms-track,
			.custom-range::-moz-range-track,
			.custom-range::-webkit-slider-runnable-track
				border: 1px solid #20a8d8
				background-color: rgba(255, 255, 255, 0.09)

			//.custom-range::-ms-thumb,
			.custom-range::-moz-range-thumb,
			.custom-range::-webkit-slider-thumb
				background-color: #383d47
				border: 1px solid #20a8d8

	.editor-control-range.dark-medium
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		align-items: center
		font-size: 0

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.number-input
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			color: rgba(255, 255, 255, 0.87)

			label
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin: 0
				padding: 0

			input
				margin: 0
				width: 60px
				height: 30px
				box-shadow: none
				padding: 0 7px
				font-size: 14px
				transition: none

				&:focus
					outline: none
					box-shadow: none
					background: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

				&:hover
					outline: none
					box-shadow: none
					background: #515b65
					border: 1px solid rgba(255, 255, 255, 0.3)

		.range-input
			margin-left: 10px
			margin-top: 3px
			width: 78px
			cursor: pointer
			transition: none

			input
				cursor: pointer

			//.custom-range::-ms-track,
			.custom-range::-moz-range-track,
			.custom-range::-webkit-slider-runnable-track
				height: 3px
				background-color: rgba(255, 255, 255, 0.09)
				transition: none

			//.custom-range::-ms-thumb,
			.custom-range::-moz-range-thumb,
			.custom-range::-webkit-slider-thumb
				width: 10px
				height: 10px
				background-color: #383d47
				border: 1px solid rgba(255, 255, 255, 0.09)
				box-shadow: none
				transition: none

		.range-input:hover

			//.custom-range::-ms-track,
			.custom-range::-moz-range-track,
			.custom-range::-webkit-slider-runnable-track
				background-color: rgba(255, 255, 255, 0.4)

			//.custom-range::-ms-thumb,
			.custom-range::-moz-range-thumb,
			.custom-range::-webkit-slider-thumb
				background-color: #383d47
				border: 1px solid rgba(255, 255, 255, 0.4)

	.editor-control-range.dark-medium.change-process

		.title
			color: #20a8d8

		.range-input

			//.custom-range::-ms-track,
			.custom-range::-moz-range-track,
			.custom-range::-webkit-slider-runnable-track
				border: 1px solid #20a8d8
				background-color: rgba(255, 255, 255, 0.09)

			//.custom-range::-ms-thumb,
			.custom-range::-moz-range-thumb,
			.custom-range::-webkit-slider-thumb
				background-color: #383d47
				border: 1px solid #20a8d8

</style>
